import { Link } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Número do pedido de venda clicável: abre a edição do pedido na tela de
// Pedidos de Venda (mesmo fluxo usado na lista de pedidos de compra).
export default function PedidoVendaLink({ saleId, children }) {
  const navigate = useNavigate();

  if (!saleId) return <>{children}</>;

  return (
    <Link
      component="button"
      type="button"
      underline="hover"
      sx={{ fontWeight: "bold", fontSize: "inherit" }}
      onClick={() => navigate("/pedidos-venda", { state: { id: saleId } })}
    >
      {children}
    </Link>
  );
}

// Remove campos internos (prefixo "_") antes de exportar para o Excel.
export const semCamposInternos = (rows) =>
  rows.map((row) =>
    Object.fromEntries(Object.entries(row).filter(([k]) => !k.startsWith("_")))
  );
